import moment, { Moment } from "moment";

import i18n from "../i18n";

type DiffResult = {
  value: number;
  type: "days" | "months" | "years";
};

export class DateValue {
  private date: Moment;

  constructor(isoString: string) {
    this.set(isoString);
  }

  set(isoString: string) {
    const isoDateFormat = "YYYY-MM-DD HH:mm:ss Z";
    this.date = moment(isoString, isoDateFormat);
  }

  toTime(): number {
    return this.date.unix();
  }

  format(): string {
    if (!this.date || !this.date.isValid()) {
      return "";
    }
    return this.date.format((window.PF.config as any).date_format);
  }

  postUntilFormat(): string {
    if (this.toTime() * 1000 > Date.now()) {
      return this.leftFormat();
    } else {
      return this.expiredFormat();
    }
  }

  leftFormat(): string {
    const { value, type } = this.diffValue(moment());
    if (value === 0) {
      return i18n.t("core:time.inWords.expiresToday");
    } else if (value < 0) {
      return this.expiredFormat();
    } else {
      return i18n.t("core:time.inWords.left", {
        time_in_words: i18n.t(`core:time.inWords.${type}`, { count: value })
      });
    }
  }

  expiredFormat(): string {
    return i18n.t("core:time.inWords.expired", { date: this.format() });
  }

  diffValue(val: Moment): DiffResult {
    let months: number;
    moment(val).fromNow(true);
    const days = this.date.diff(val, "days");
    if (days > 30 * 2) {
      months = this.date.diff(val, "months");
      return { value: months, type: "months" };
    }
    if (days > 356 * 2) {
      const years = this.date.diff(val, "years");
      return { value: years, type: "years" };
    }

    return { value: days, type: "days" };
  }
}
